/* 
 * Neoweb Framework Template
 * version: 02-2022
 * author: neoweb.fr 
 */
;(function(defaults, $, window, document, undefined) {

    'use strict';

    var userAgent = navigator.userAgent,
        userPlatform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod']
    ;
    $.extend({
        setup : function(options) {
            return $.extend(defaults, options);
        },

        screenBreakpoint: function() {
            return {
                xs: 0,
                sm: 575,
                md: 767,
                lg: 991,
                xl: 1100
            }
        },

        userAgent: function() {
            return userAgent;
        },

        userOS: function() {
            var os = null;
            if (macosPlatforms.indexOf(userPlatform) !== -1) {
                os = 'Mac OS';
            } else if (iosPlatforms.indexOf(userPlatform) !== -1) {
                os = 'iOS';
            } else if (windowsPlatforms.indexOf(userPlatform) !== -1) {
                os = 'Windows';
            } else if (/Android/.test(userAgent)) {
                os = 'Android';
            } else if (!os && /Linux/.test(userPlatform)) {
                os = 'Linux';
            }

            return os;
        },

        userBrowser: function() {
            var browser = null;
            if( (!!window.opr && !!opr.addons) || !!window.opera || userAgent.indexOf(' OPR/') >= 0 ) {
                browser = 'Opera';
            } else if( typeof InstallTrigger !== 'undefined' ) {
                browser = 'Firefox';
            } else if( !!window.chrome && !!window.chrome.webstore ) {
                browser = 'Chrome';
            } else if ( /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)) ) {
                browser = 'Safari';
            } else if ( /*@cc_on!@*/false || !!document.documentMode ) {
                browser = 'IE';
            } else if ( !!window.StyleMedia ) {
                browser = 'Edge';
            }

            return browser;
        },

        detectIE: function( version ) {

            version = !version ? 10 : version;

            var msie = userAgent.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), version);
            }

            var trident = userAgent.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = userAgent.indexOf('rv:');
                return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), version);
            }

            var edge = userAgent.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), version);
            }

            return false;
        },

        deviceAndroid: function() {
            return Boolean( userAgent.match(/Android/i) );
        },
        deviceBlackBerry: function() {
            return Boolean( userAgent.match(/BlackBerry/i) );
        },
        deviceiOS: function() {
            return Boolean( userAgent.match(/iPhone|iPad|iPod/i) );
        },
        deviceiPhone: function() {
            return Boolean( userAgent.match(/iPhone/i) );
        },
        deviceiPad: function() {
            return Boolean( userAgent.match(/iPad/i) );
        },
        deviceOpera: function() {
            return Boolean( userAgent.match(/Opera Mini/i) );
        },
        deviceWindows: function() {
            return Boolean( userAgent.match(/IEMobile/i) );
        },
        deviceAny: function() {
            return Boolean(this.deviceAndroid() || this.deviceBlackBerry() || this.deviceiOS() || this.deviceOpera() || this.deviceWindows());
        },


        scrollToHash: function( hash, offset, duration ) {

            if( hash && $(hash).length )
            {
                var d = duration != undefined ? parseInt(duration) : 1200;
                $("html, body").animate({
                    scrollTop: $(hash).offset().top - parseInt(offset)
                }, d);
            }
            return false;
        },


        wholeClick: function( container, target ) {

            if( container && target )
            {
                var $container = $(container);
                var $target = $(target);

                $(document).on('click', $container, function(e) {
                    var $item = $(e.target).closest(container);
                    var href = $item.find( target ).attr('href');
                    if( href ) {
                        window.location.href = href;
                    }
                });
            }
        },


    }).fn.extend({

        stickyHeader: function() {

            var ownDefaults = {
                    offset: 100,
                },

                // Merge options with default
                options = $.extend({}, ownDefaults, options);

            return $(this).each(function() {

                var $element = $(this);
                // var $autoOffset = option.offset == 'auto';

                var updateState = function( offset ) {

                    var o = !offset ?  options.offset : offset;

                    if ($(document).scrollTop() > o ){
                        $element.addClass("sticky");
                        $('body').addClass("is-sticky").removeClass('unsticky');
                    }else{
                        $element.removeClass("sticky");
                        $('body').removeClass("is-sticky").addClass("unsticky");
                    }
                };

                $(window).scroll(function() {
                    updateState();
                });

                updateState();

            })

        },

        navbarCollapse: function(options) {

            var ownDefaults = {
                    showChildren: true,
                    iconCaretOpen: 'fa-angle-right',
                    iconCaretClose: 'fa-angle-down',
                    openFirstItem: false,
                    toggleParentOnly: false,
                    append: []
                },

                // Merge options with default
                options = $.extend({}, ownDefaults, options);

            return $(this).each(function () {

                var $body = $('body');
                var _this = this;
                var $toggleOpen = $(this);
                var $target = $($(this).data('target'));
                var $toggleClose = $target.find('.navbar-toggle-close');
                var $panelMenuClone = $target.find('#navbar-menu-clone');

                $panelMenuClone.append( $( $(this).data('menu') ).find('.nav:not(.sub-menu)').clone() );
                $body.append( $('<div id="navbar-panel-overlay" />'));

                var $panelOverlay = $('#navbar-panel-overlay');

                $(window).resize(function() {
                    if( $toggleOpen.is(':visible') == false ) {
                        closePanel();
                    }
                    setTimeout(function() {
                        updateChildToggle();
                    }, 200);
                });

                $toggleOpen.on('click touchend', function (e) {
                    e.preventDefault();
                    togglePanel();

                });
                $toggleClose.on('click touchend', function (e) {
                    e.preventDefault();
                    closePanel();
                });
                $panelOverlay.on('click touchend', function (e) {
                    e.preventDefault();
                    closePanel();
                });

                var togglePanel = function() {
                    $target.toggleClass('in').height('auto');
                    $target.find('.navbar-collapse').toggleClass('in');
                    $body.toggleClass('navbar-panel-open');
                }
                var openPanel = function() {
                    $target.addClass('in').height('auto');
                    $target.find('.navbar-collapse').addClass('in');
                    $body.addClass('navbar-panel-open');
                }
                var closePanel = function() {
                    $target.removeClass('in').height('auto');
                    $target.find('.navbar-collapse').removeClass('in');
                    $body.removeClass('navbar-panel-open');
                }

                /**
                 * Create toggle caret
                 */
                var createChildToggle = function( $toggler ) {
                    var h = $toggler.outerHeight();

                    var html = '<span class="nav-child-toggle" '+ (options.toggleParentOnly ? 'style="height:'+h+'px"' : '' )+'><span class="caret-toggle" style="height:'+h+'px;line-height:'+h+'px;">'
                        + '<i class="icon-open far '+ options.iconCaretOpen +'"></i>'
                        + '<i class="icon-close far '+ options.iconCaretClose +'"></i>'
                        +'</span></span>'

                    return $(html);
                }

                /**
                 * Update toggle size when resize
                 */
                var updateChildToggle = function() {
                    $panelMenuClone.find('.nav-child-toggle').each(function () {
                        var h = $(this).closest('li').find('> a').outerHeight();

                        if( options.toggleParentOnly == true ) {
                            $(this).css({
                                'height': h
                            });
                        }

                        $(this).find('.caret-toggle').css({
                            'height': h+'px',
                            'line-height': h+'px'
                        });
                    });
                }

                /**
                 * Append somes elements to Nav Panel
                 */
                $.each( options.append, function(elm) {
                    $panelMenuClone.append( $(this).clone() );
                });

                var $nav = $panelMenuClone.find('.nav');
                $nav.find(' > .deeper, > .menu-item-has-children').each(function () {

                    var $elm = $(this);
                    var $child = $elm.children('.nav-child, .sub-menu');

                    if (options.toggleParentOnly == true) {
                        $elm.addClass('nav-toggle-only');
                    }

                    if (options.showChildren == false) {

                        $(this).addClass('nav-child-hidden');

                        // Création du toggle pour chaque élément de menu enfant
                        $(this).prepend(createChildToggle($(this).find('> a')));

                        // Gestion du clic sur le bouton toggle
                        $(this).find('.nav-child-toggle').on('click', function (e) {
                            e.preventDefault();

                            // Fermer tous les autres sous-menus
                            $nav.find('.in').not($elm).removeClass('in'); // fermer les autres sous-menus ouverts

                            // Basculer l'état du sous-menu actuel
                            $elm.toggleClass('in'); // ouvrir/fermer le sous-menu actuel

                            // Déclencher l'événement personnalisé après la bascule
                            $toggleOpen.trigger('navchildtoggle', [$elm, $elm.hasClass('in'), _this]);
                        });

                        // Ajouter la classe 'in' si l'élément est actif ou dans le chemin actuel
                        if ($(this).hasClass('active')
                            || $(this).hasClass('current')
                            || $(this).hasClass('current-menu-item')
                            || $(this).hasClass('current-menu-ancestor')
                        ) {
                            $(this).addClass('in');
                        }

                    }

                });

                //Option pour ouvrir le premier élément par défaut si spécifié (uniquement sur la page d'accueil)
                if ($('body').hasClass('home') && options.openFirstItem) {
                    var $i = $panelMenuClone.find('.main-menu > li').eq(0);
                    $i.addClass('in');
                }

            });
        },

        systemMessage: function() {
            return $(this).each(function() {

                var $msg = $(this);
                $('body').bind('click touch', function(e) {
                    $msg.delay(0).hide();
                });
                $msg.delay(7000).fadeOut(500);
            });

        },

        textToggle: function(options) {

            var ownDefaults = {

                },

                // Merge options with default
                options = $.extend({}, ownDefaults, options);

            return $(this).each(function() {
                var $container = $(this);

                var $target     = $container.find('.text-toggle');
                var $btnOpen    = $container.find('.btn-toggle .btn-toggle-open');
                var $btnClose   = $container.find('.btn-toggle .btn-toggle-close');

                $btnOpen.on('click', function (e) {
                    $container.addClass('in');
                });
                $btnClose.on('click', function (e) {
                    $container.removeClass('in');
                });
            });
        },

        scrollToHash: function(options) {

            var ownDefaults = {
                    offset: 0,
                },

                options = $.extend({}, ownDefaults, options);

            return $(this).each(function() {

                var $elm = $(this);
                $elm.on('click', function (e) {
                    e.preventDefault();
                    var hash = $(this).attr('href');
                    $.scrollToHash(hash, options.offset);
                });
            });
        },

        stopClick: function() {
            return $(this).each(function() {

                var $elements = $(this);

                $elements.on('click', function (e) {
                    e.stopPropagation();
                });

            });
        },
    });
})({

}, jQuery, window, document);
